import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TourCard } from '@shared/components/ui/TourCard'
import { useNavigate } from 'react-router'
import { can } from '@utils/permissions'

import { CustomerGroupsTourList } from '../components/CustomerGroupsTourList'
import { PaymentHistoryStatistics } from '../components/statistics/PaymentHistoryStatistics'

export const PaymentHistoryTourListView: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Stack
      gap={4}
      sx={{
        p: { xs: 2, md: 4, lg: 6 },
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto'
      }}
    >
      <Box>
        <Typography variant="h4">{t('payment.paymentHistory')}</Typography>
        <Typography >{t('payment.allowedTours')}</Typography>
      </Box>

      <PaymentHistoryStatistics />

      {(can('scope:admin')) && (
        <Box>
          <Typography
            variant="h5"
            sx={{ mb: 2 }}
          >{t('payment.allTours')}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <TourCard
              size='medium'
              tour={{
                title: t('payment.allTours'),
                subtitle: t('payment.allToursSubtitle')
              }}
              onTourSelect={() => navigate('all-tours')}
            />
          </Box>
        </Box>
      )}
      <Box
        sx={{
          position: 'relative'
        }}
      >
        <CustomerGroupsTourList />
      </Box>
    </Stack>
  )
}
